"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Switch = exports.Key = exports.Input = exports.Container = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Container = exports.Container = _styledComponents["default"].label.withConfig({
  displayName: "Switchstyle__Container",
  componentId: "sc-1qkajny-0"
})({
  position: 'relative',
  display: 'inline-block',
  cursor: 'pointer',
  fontSize: 0,
  verticalAlign: 'middle'
});
var Switch = exports.Switch = _styledComponents["default"].div.withConfig({
  displayName: "Switchstyle__Switch",
  componentId: "sc-1qkajny-1"
})(function (_ref) {
  var color = _ref.theme.color;
  return {
    transition: '0.4s',
    background: color.neutral['08'],
    border: "1px solid ".concat(color.brandPrimary.light),
    borderRadius: 30,
    width: 36,
    height: 16
  };
});
var Key = exports.Key = _styledComponents["default"].span.withConfig({
  displayName: "Switchstyle__Key",
  componentId: "sc-1qkajny-2"
})(function (_ref2) {
  var color = _ref2.theme.color;
  return {
    transition: '0.4s',
    background: color.neutral['08'],
    border: "1px solid ".concat(color.brandPrimary.light),
    display: 'block',
    borderRadius: '50%',
    width: 16,
    height: 16,
    position: 'absolute',
    top: 0,
    left: 0
  };
});
var Input = exports.Input = _styledComponents["default"].input.withConfig({
  displayName: "Switchstyle__Input",
  componentId: "sc-1qkajny-3"
})(function (_ref3) {
  var color = _ref3.theme.color;
  return _defineProperty(_defineProperty(_defineProperty({}, ":checked ~ ".concat(Switch), _defineProperty({
    background: color.brandPrimary.light,
    borderColor: color.brandPrimary.dark
  }, Key, {
    transform: 'translateX(20px)',
    borderColor: color.brandPrimary.dark
  })), ":disabled ~ ".concat(Switch), _defineProperty({
    borderColor: color.neutral['04']
  }, Key, {
    borderColor: color.neutral['04']
  })), ":disabled:checked ~ ".concat(Switch), {
    background: color.line.medium
  });
});